import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { intToString } from 'helper';

/*
 * Metric card.
 *
 * The large pale line-art icon is gone — it was one of the 17 hand-drawn SVGs
 * and carried no information. The freed space goes to the delta line. `icon`
 * and `image` are still accepted so call sites don't break, but ignored.
 */
function InfoCard({
  containerClassName,
  labelClassName,
  totalClassName,
  label,
  total,
  delta,
  isLoading,
  loader,
}) {
  if (isLoading) return loader;

  return (
    <div
      className={cn(
        'bg-white border border-neutral-200 rounded-md p-5',
        containerClassName,
      )}
    >
      <div className="whitespace-nowrap">
        <h5
          className={cn(
            'text-xs font-semibold uppercase tracking-[.05em] text-neutral-500',
            labelClassName,
          )}
        >
          {label}
        </h5>
        <div
          className={cn(
            'mt-2 text-3xl font-bold tracking-[-.02em] tabular-nums text-neutral-900',
            totalClassName,
          )}
        >
          {intToString(+total)}
        </div>
      </div>
      {delta && <div className="mt-3 text-sm">{delta}</div>}
    </div>
  );
}

InfoCard.defaultProps = {
  containerClassName: '',
  labelClassName: '',
  totalClassName: '',
  delta: null,
  isLoading: false,
};

InfoCard.propTypes = {
  containerClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  totalClassName: PropTypes.string,
  label: PropTypes.string.isRequired,
  total: PropTypes.string.isRequired,
  delta: PropTypes.node,
  isLoading: PropTypes.bool,
  loader: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.instanceOf(Object),
    PropTypes.node,
    PropTypes.string,
  ]).isRequired,
};

export default InfoCard;
